import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import BookPage from "@/pages/BookPage";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingCancel from "@/pages/BookingCancel";
import MeetingRoom from "@/pages/MeetingRoom";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProfile from "@/pages/AdminProfile";
import AdminAvailability from "@/pages/AdminAvailability";
import ProtectedRoute from "@/components/ProtectedRoute";
import { LangProvider } from "@/i18n/LangContext";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#1A1A1A",
              color: "#F4F1EA",
              border: "1px solid #1A1A1A",
              borderRadius: 2,
              fontFamily: "Manrope, sans-serif",
              letterSpacing: "0.02em",
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/booking/success" element={<BookingSuccess />} />
            <Route path="/booking/cancel" element={<BookingCancel />} />
            <Route path="/meeting/:id" element={<MeetingRoom />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/profile" element={<ProtectedRoute><AdminProfile /></ProtectedRoute>} />
            <Route path="/admin/availability" element={<ProtectedRoute><AdminAvailability /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
